import React from "react";
import "./FirstVsBestAttemptTable.css";

// Table version of the "First Attempt vs Best Attempt By Case" bar graph, used in
// the PDF export where the bar graph is too wide for paper.
//
// Expects the formatted jsonreport from ReportCard.formatJsonReport:
// [{ title: "Pediatrics", scores: [ { CaseId, CaseDignosis, FirstCaseAttemptGrade, BestCaseAttemptGrade, ... } ] }, ...]

const getCaseNumber = (score) => score.CaseId ?? "—";

// "CaseDignosis" is spelled this way in the API response
const getDiagnosis = (score) => score.CaseDignosis || "—";

const hasValue = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  !isNaN(Number(value));

// One decimal place, dropping a trailing ".0" (12.5 -> "12.5", 20 -> "20")
const formatNumber = (value) => String(Math.round(Number(value) * 10) / 10);

const formatGrade = (value) =>
  hasValue(value) ? `${formatNumber(value)}%` : "—";

const renderChange = (first, best) => {
  if (!hasValue(first) || !hasValue(best)) return "—";
  const diff = Math.round((Number(best) - Number(first)) * 10) / 10;
  if (diff > 0)
    return <span className="firstVsBestChangeUp">+{formatNumber(diff)}</span>;
  if (diff < 0)
    return <span className="firstVsBestChangeDown">{formatNumber(diff)}</span>;
  return "0";
};

const FirstVsBestAttemptTable = ({ jsonreport }) => {
  const categories = (jsonreport || []).filter(
    (category) => category.scores && category.scores.length > 0,
  );

  return (
    <div className="reportCardModuleContainer">
      <div className="reportCardModuleHeaderContainer">
        <p className="reportCardModuleHeaderText">
          First Attempt vs Best Attempt By Case
        </p>
      </div>
      <div className="reportCardModuleBodyContainer">
        {categories.map((category) => (
          <div className="firstVsBestCategory" key={category.title}>
            <h3 className="firstVsBestCategoryTitle">{category.title}</h3>
            <table className="firstVsBestTable">
              <thead>
                <tr>
                  <th className="firstVsBestCaseNumber">Case #</th>
                  <th>Diagnosis</th>
                  <th className="firstVsBestNumeric">First Attempt</th>
                  <th className="firstVsBestNumeric">Best Attempt</th>
                  <th className="firstVsBestNumeric">Change</th>
                </tr>
              </thead>
              <tbody>
                {category.scores.map((score) => (
                  <tr key={`${category.title}-${score.CaseId}`}>
                    <td className="firstVsBestCaseNumber">
                      {getCaseNumber(score)}
                    </td>
                    <td>{getDiagnosis(score)}</td>
                    <td className="firstVsBestNumeric">
                      {formatGrade(score.FirstCaseAttemptGrade)}
                    </td>
                    <td className="firstVsBestNumeric">
                      {formatGrade(score.BestCaseAttemptGrade)}
                    </td>
                    <td className="firstVsBestNumeric">
                      {renderChange(
                        score.FirstCaseAttemptGrade,
                        score.BestCaseAttemptGrade,
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FirstVsBestAttemptTable;
